// extracted by mini-css-extract-plugin
export default {"card":"CardUser_card__CRvhW","usercard":"CardUser_usercard__-rvQe","card__name":"CardUser_card__name__eCmrK","card__email":"CardUser_card__email__AcaaH","btn":"CardUser_btn__mFd-h"};